import React, { useEffect, useState } from 'react'
import { isLocal } from '../../utility'
import './TimerBanner.css'

const TimerBanner = () => {
  const [timeLeft, setTimeLeft] = useState(0)
  const [hideForFooter, setHideForFooter] = useState(false)
  const bannerRef = React.useRef(null)

  // Calculate initial time left
  const hideAt = new Date(Date.UTC(2026, 5, 28, 19, 0, 0))
  const isVisible = timeLeft > 0

  useEffect(() => {
    // Set initial time left
    const updateTime = () => {
      const now = new Date()
      setTimeLeft(Math.max(0, hideAt.getTime() - now.getTime()))
    }
    updateTime()
    const interval = setInterval(updateTime, 1000)
    return () => clearInterval(interval)
  }, [hideAt])

  // Hide banner when it overlaps with Footer
  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('.Footer')
      const banner = bannerRef.current
      if (footer && banner) {
        const footerRect = footer.getBoundingClientRect()
        if (footerRect.top < window.innerHeight && footerRect.bottom > 0) {
          setHideForFooter(true)
        } else {
          setHideForFooter(false)
        }
      } else {
        setHideForFooter(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    window.addEventListener('resize', handleScroll)
    handleScroll()
    return () => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleScroll)
    }
  }, [])

  if (!isVisible) return null

  // Format timeLeft as Timer-item blocks for days, hours, minutes, seconds
  const formatTime = (ms) => {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000))
    const days = String(Math.floor(totalSeconds / 86400)).padStart(2, '0')
    const hours = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(
      2,
      '0'
    )
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      '0'
    )
    const seconds = String(totalSeconds % 60).padStart(2, '0')

    const timeLeft = [
      { value: days, label: 'Days' },
      { value: hours, label: 'Hours' },
      { value: minutes, label: 'Minutes' },
      { value: seconds, label: 'Secs' },
    ]

    return (
      <div className="u-flex u-flexRow u-textBold">
        {timeLeft.map(({ value, label }, idx) => (
          <React.Fragment key={label}>
            <div className="Timer-item u-textColorWhite u-flex u-flexCol u-flexAlignItemsCenter u-textAlignCenter">
              <div className="Timer-value  u-sm-textSizeMsrp2  u-sm-textSizeMsrp2 u-textSizeMsrp3">
                {value}
              </div>
              <div className="Timer-label u-textPrimary u-md-textSizeMsrm1 u-textSizeMsrm1 u-textCenter">
                {label}
              </div>
            </div>

            {idx < timeLeft.length - 1 && (
              <p className="u-textSizeMsrp3 u-textBold u-textSolid">:</p>
            )}
          </React.Fragment>
        ))}
      </div>
    )
  }

  return (
    <>
      <div
        className={`Timer-Banner${hideForFooter ? ' u-hidden' : ''}`}
        ref={bannerRef}
      >
        <div className="u-posRelative u-flex u-flexAlignItemsCenter u-sizeFull">
          <img
            src={`${isLocal() ? '/cti-site' : ''}/webfiles/latest/assets/cti/images/timer-banner/pattern_countdown.png`}
            alt="March Madness Countdown 2026"
            className="Timer-Banner-img u-displayBlock u-sizeFull"
          />
          <div className="Timer-Banner-timer u-sizeConstrained u-sm-sizeConstrainedFlush u-textColorWhite u-posAbsolute u-flex u-flexAlignItemsCenter u-flexJustifyCenter">
            <div className="u-flex u-flexAlignItemsCenter u-sizeFull">
              <div>{formatTime(timeLeft)}</div>
              <div className="u-lg-flex u-lg-flexAlignItemsCenter u-sm-marginLeft5gu u-md-marginLeft5gu u-marginLeft15gu">
                <h1 className="u-textColorWhite u-textBold u-sm-textSizeMsrp1 u-md-textSizeMsrp2 u-lg-textSizeMsrp3 u-md-textCenter">
                  Knockout play is near. &nbsp;
                </h1>
                <p className="quote u-lg-marginLeft3gu u-sm-textSizeMsrp u-md-textSizeMsrp3 u-lg-textSizeMsrp3">
                  Our bracket will be available soon.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TimerBanner
